import React, {useState} from 'react';
import GameBoard from '../RoomComponents/GameBoard';
import PlayerChoices from '../RoomComponents/PlayerChoices';

const GameArea = ({ gameSyncData, player, alertMessage }) => {
    //console.log('GameArea:', gameSyncData, player); roomId
    const {roomId, gameOver, gameMode} = gameSyncData;
    const category = gameSyncData.game.category;
    const rounds = gameSyncData?.game?.currentRound;
    const totalRounds = gameSyncData?.game?.rounds;
    const currentTeamIndex = gameSyncData?.currentTeamIndex || 0;

    const isActor = player.id === gameSyncData.actorId;
    const isActorsTeam = Object.values(gameSyncData.teams || {}).some(team =>
        team.includes(player.id) && team.includes(gameSyncData.actorId)
    );
    const [copied, setCopied] = useState(false);

    const showGameBoard = (gameSyncData.gameMode === 'single' && isActor) ||
                          (gameSyncData.gameMode === 'team' && isActorsTeam && isActor);

    const handleCopy = () => {
        navigator.clipboard.writeText(roomId).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <div class="h-[80vh] rounded-xl w-full content-center animate-fade-in space-y-6">

        <div className="bg-white rounded-3xl p-4 sm:p-6 shadow-lg space-y-2 border-4 border-[#022E7E] max-w-md mx-auto animate-fadeIn text-sm sm:text-base">
            <p className="inline-flex flex-wrap items-center gap-2 sm:gap-3 text-[#022E7E] font-semibold">
                🔑 Room ID: 
                <code 
                className="bg-gradient-to-t from-[#022E7E] to-[#0466c8] text-white px-3 py-1 font-mono text-base sm:text-lg rounded-md border border-white shadow cursor-pointer hover:scale-105 transition-all duration-200 notranslate" 
                translate="no" 
                onClick={handleCopy}
                >
                {roomId}
                </code>
                {copied && (
                <span className="text-green-400 text-xs sm:text-sm font-medium animate-pulse">(Copied!)</span>
                )}
            </p>

            <p className="text-[#022E7E] text-base sm:text-lg font-semibold">
                📚 Category: <span className="font-bold text-[#022E7E]">{category}</span>
            </p>

            {!gameOver && (
                <p className="text-[#022E7E] text-base sm:text-lg font-semibold">
                {rounds === 0 ? (
                    <span className="italic animate-pulse">⏳ Waiting for players...</span>
                ) : (
                    <>
                    🎯 Round: <span className="font-bold notranslate" translate="no">{rounds} / {totalRounds}</span>
                    {gameMode === 'team' && (
                        <span> — 🧑‍🤝‍🧑 Team <span className="font-bold notranslate" translate="no">{currentTeamIndex + 1}</span> is Playing</span>
                    )}
                    </>
                )}
                </p>
            )}
            </div>


            {gameSyncData.gameStarted ? (
                <>
                    {showGameBoard ? (
                        <GameBoard gameSyncData={gameSyncData} alertMessage={alertMessage} />
                    ) : (
                        <PlayerChoices gameSyncData={gameSyncData} player={player} alertMessage={alertMessage} />
                    )}
                </>
            ) : null}
       </div>
    );
};

export default GameArea;